import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  imagePickerContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  imagePreview: {
    width: '80px',
    height: '80px',
    marginLeft: '10px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    objectFit: 'cover',
  },
  textField: {
    flex: 1, 
    '& .MuiInputBase-root': {
      height: '40px',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      padding: '0 14px',
    },
    '& .MuiInputBase-input': {
      padding: '10.5px 0',
      textAlign: 'left',
    },
  },
});

function ImagePicker({ url, onChange, id }) {
  const classes = useStyles();
  const [currentUrl, setCurrentUrl] = useState(url);

  useEffect(() => {
    setCurrentUrl(url);
  }, [url]);

  const handleChange = (event) => {
    const newUrl = event.target.value;
    setCurrentUrl(newUrl);
    if (onChange) {
      onChange(newUrl);
    }
  };

  return (
    <div className={classes.imagePickerContainer}>
      <TextField
        id={id}
        value={currentUrl}
        onChange={handleChange}
        className={classes.textField}
      />
      {currentUrl && <img src={currentUrl} alt="Preview" className={classes.imagePreview} />}
    </div>
  );
}

export default ImagePicker;
